import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const HOOK_ORIENTATION_URL = `${POSITION_PROPERTY_URL}/hook-orientations`

const errors = createHandbookResponseErrors('ориентацию зацепов', 'ориентаций зацепов')

export const HookOrientationApi = createNewHandbookApi(HOOK_ORIENTATION_URL, errors)
